import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const share: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13.86-7.36Q14-7.2 14-7q0 .204-.14.344l-4 4a.5.5 0 0 1-.36.156.52.52 0 0 1-.36-.14A.52.52 0 0 1 9-3v-2H7.25q-.767 0-1.375.047-.596.048-1.203.172a4 4 0 0 0-1.031.328q-.44.206-.828.547-.377.329-.625.781a4.6 4.6 0 0 0-.375 1.078q-.141.626-.141 1.422 0 .422.047.969 0 .045.015.172c.008.093.016.164.016.218q-.002.105-.062.188A.23.23 0 0 1 1.5 1c-.086 0-.156-.043-.219-.125a2 2 0 0 1-.093-.187 4 4 0 0 1-.11-.235C1.035.367 1.008.313 1 .281Q-.001-1.95 0-3.25q0-1.56.422-2.61C1.266-7.952 3.539-9 7.25-9H9v-2q0-.201.14-.344a.5.5 0 0 1 .36-.156q.2 0 .36.14zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11.5)"
    />
  ),
  svgProps: {
    height: "12.5",
    width: "14",
  }
};
